require('../../../modules/es.array.filter');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').filter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/filter.js
// module id = 468
// module chunks = 0 1